<style lang="less">
    @import "./newsManage.less";
</style>
<template>
    <div class="search">
        <Row>
            <Col>
                <Card>
                    <Row @keydown.enter.native="handleSearch">
                        <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
                            <Form-item label="新闻标题" prop="messageTitle">
                                <Input type="text" v-model="searchForm.messageTitle" placeholder="请输入新闻标题" clearable style="width: 200px"/>
                            </Form-item>
                            <Form-item label="新闻内容" prop="messageContent">
                                <Input type="text" v-model="searchForm.messageContent" placeholder="请输入新闻内容" clearable style="width: 200px"/>
                            </Form-item>
                            <Form-item style="margin-left:-35px;" class="br">
                                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                                <Button @click="handleReset">重置</Button>
                                <a class="drop-down" @click="dropDown">{{dropDownContent}}
                                    <Icon :type="dropDownIcon"></Icon>
                                </a>
                            </Form-item>
                        </Form>
                    </Row>
                    <Row class="operation">
                        <Button @click="add" type="primary" icon="md-add">创建新闻</Button>
                        <Button @click="delAll" icon="md-trash">批量删除</Button>
                        <Button @click="getDataList" icon="md-refresh">刷新</Button>
                        <circleLoading v-if="operationLoading"/>
                    </Row>
                    <Row>
                        <Alert show-icon>
                            已选择 <span class="select-count">{{selectCount}}</span> 项
                            <a class="select-clear" @click="clearSelectAll">清空</a>
                        </Alert>
                    </Row>
                    <Row>
                        <Table :loading="loading" border :columns="columns" :data="data"  sortable="custom" @on-sort-change="changeSort" @on-selection-change="showSelect" ref="table"></Table>
                    </Row>
                    <Row type="flex" justify="end" class="page">
                        <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    import {deleteNews,getNewsData} from "@/api/index";
    import circleLoading from "../../my-components/circle-loading.vue";

    export default {
        name: "message-manage",
        components: {
            circleLoading
        },
        data() {
            return {
                loading: true, // 表单加载状态
                userLoading: true,
                //tableHeigh: '450px',
                operationLoading: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                drop: false,
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                searchForm: {
                    // 搜索框对应data对象
                    messageTitle: "",
                    messageContent: "",
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    startDate: "", // 起始时间
                    endDate: "" // 终止时间
                },
                selectDate: null, // 选择日期绑定modal
                columns: [
                    // 表头
                    {
                        type: "selection",
                        width: 60,
                        align: "center"
                    },
                    {
                        type: "index",
                        title: "序号",
                        width:70,
                        align: "center"
                    },
                    {
                        title: "新闻标题",
                        key: "messageTitle",
                        width: 200,
                        ellipsis:true,
                        tooltip:true,
                    },
                    {
                        title: "新闻摘要",
                        key: "summary",
                        width: 200,
                        ellipsis:true,
                        tooltip:true,
                    },
                    {
                        title: "新闻排序",
                        key: "sortOrder",
                        width: 120,
                        align: "center"
                    },
                    {
                        title: "创建时间",
                        key: "createTime",
                        width: 180,
                        sortable: true
                    },
                    {
                        title: "修改时间",
                        key: "updateTime",
                        width: 180,
                        sortable: true
                    },
                    {
                        title: "操作",
                        key: "action",
                        width: 280,
                        align: "center",
                        fixed: "right",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row);
                                            }
                                        }
                                    },
                                    "编辑"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small"
                                        },
                                        on: {
                                            click: () => {
                                                this.remove(params.row);
                                            }
                                        }
                                    },
                                    "删除"
                                )
                            ]);
                        }
                    }
                ],
                data: [], // 表单数据
                total: 0, // 表单数据总数
                dictMessageType: []
            };
        },
        methods: {
            init() {
                this.getDataList();
            },
            dropDown() {
                if (this.drop) {
                    this.dropDownContent = "展开";
                    this.dropDownIcon = "ios-arrow-down";
                } else {
                    this.dropDownContent = "收起";
                    this.dropDownIcon = "ios-arrow-up";
                }
                this.drop = !this.drop;
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            selectDateRange(v) {
                if (v) {
                    this.searchForm.startDate = v[0];
                    this.searchForm.endDate = v[1];
                }
            },
            getDataList() {
                this.loading = true;
                getNewsData(this.searchForm).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            handleSearch() {
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.getDataList();
            },
            handleReset() {
                this.$refs.searchForm.resetFields();
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.selectDate = null;
                this.searchForm.startDate = "";
                this.searchForm.endDate = "";
                // 重新加载数据
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            add() {
                let query = {type: 0, backRoute: this.$route.name};
                this.$router.push({
                    name: "add_edit_news",
                    query: query
                });
            },
            edit(v) {
                let query = {type: 1, id: v.id, backRoute: this.$route.name};
                this.$router.push({
                    name: "add_edit_news",
                    query: query
                });
            },
            remove(v) {
                this.$Modal.confirm({
                    title: "确认删除",
                    // 记得确认修改此处
                    content: "您确认要删除?",
                    onOk: () => {
                        // 删除
                        this.operationLoading = true;
                        deleteNews(v.id).then(res => {
                            this.operationLoading = false;
                            if (res.status === true) {
                                this.$Message.success("操作成功");
                                this.getDataList();
                            }
                        });
                    }
                });
            },
            showSelect(e) {
                this.selectList = e;
                this.selectCount = e.length;
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
            delAll() {
                if (this.selectCount <= 0) {
                    this.$Message.warning("您还未选择要删除的数据");
                    return;
                }
                this.$Modal.confirm({
                    title: "确认删除",
                    content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
                    onOk: () => {
                        let ids = "";
                        this.selectList.forEach(function (e) {
                            ids += e.id + ",";
                        });
                        ids = ids.substring(0, ids.length - 1);
                        // 批量删除
                        this.operationLoading = true;
                        deleteNews(ids).then(res => {
                            this.operationLoading = false;
                            if (res.status === true) {
                                this.$Message.success("操作成功");
                                this.clearSelectAll();
                                this.getDataList();
                            }
                        });
                    }
                });
            }
        },
        mounted() {
            this.init();
            //this.tableHeigh = window.innerHeight - this.$refs.table.$el.offsetTop;
        },watch: {
            // 监听路由变化
            $route(to, from) {
                this.getDataList();
            }
        }
    };
</script>